export const base_api_url = "http://quickshopdata.srushtisoft.com";
//export const base_api_url = "http://srushtisoft.com:8788";

export const product_images_url = base_api_url + '/ProductImages/';